import { UseQueryResult } from '@tanstack/react-query'
import React from 'react'

import { GlobalSearchResultsItem } from '../../../../../types/responses/global-search'
import SkeletonBox from '../../../../skeleton/SkeletonBox'
import { useGlobalSearch } from '../../hooks/useGlobalSearch'
import SearchResults from './components/SearchResults'

interface Props {
  globalSearchQuery: UseQueryResult<GlobalSearchResultsItem>
  searchResults?: GlobalSearchResultsItem
}

const SearchBoxResults: React.FC<Props> = ({
  globalSearchQuery,
  searchResults,
}) => {
  const { searchTerm } = useGlobalSearch()

  if (!searchTerm) {
    return null
  }

  if (globalSearchQuery.isLoading) {
    return (
      <div className="d-flex flex-column gap-2">
        {new Array(3).fill('x').map((_, index) => (
          <SkeletonBox key={index} style={{ height: '20px' }} />
        ))}
      </div>
    )
  }

  if (globalSearchQuery.error) {
    throw globalSearchQuery.error
  }

  if (searchResults) {
    return (
      <SearchResults
        searchResults={searchResults}
        isFetching={globalSearchQuery.isFetching}
      />
    )
  }

  return null
}

export default SearchBoxResults
